export enum Entgeltart {
  FESTGEHALT_MONATSLOHN_TARIFGEBUNDEN = 'Festgehalt / Monatslohn tarifgebunden',
  FESTGEHALT_MONATSLOHN_NICHT_TARIFGEBUNDEN = 'Festgehalt / Monatslohn nicht tarifgebunden',
  STUNDENLOHN_TARIFGEBUNDEN = 'Stundenlohn tarifgebunden',
  STUNDENLOHN_NICHT_TARIFGEBUNDEN = 'Stundenlohn nicht tarifgebunden',
  AKKORDLOHN_TARIFGEBUNDEN = 'Akkordlohn tarifgebunden',
  AKKORDLOHN_NICHT_TARIFGEBUNDEN = 'Akkordlohn nicht tarifgebunden',
  OHNE_ENTGELT_NUR_UNFALLVERSICHERUNGSPFLICHT = 'ohne Entgelt (nur Unfallversicherungspflicht)',
}

export function isTypeWithTariff(type: Entgeltart): boolean {
  return (
    type === Entgeltart.FESTGEHALT_MONATSLOHN_TARIFGEBUNDEN ||
    type === Entgeltart.STUNDENLOHN_TARIFGEBUNDEN ||
    type === Entgeltart.AKKORDLOHN_TARIFGEBUNDEN
  );
}
